import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { ISettingForm, ISetting } from 'src/models/setting.model';
import { useSettingContext } from 'src/contexts/setting.context';
import Lang from 'src/libraries/language';
import { getSettingStatus } from 'src/selectors/setting.selector';
import { actionTypes } from 'src/ducks/setting.duck';
import ConfigurationSettingsForm from '../configuration-settings-form/configuration-settings-form.component';
import style from '../configuration-settings-list/configuration-settings-list.module.scss';

type IProp = {
  data: ISetting;
};

const ConfigurationSettingsEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useSettingContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [field1IsNull, setField1IsNull] = useState(true);
  const [field2IsNull, setField2IsNull] = useState(true);
  const [field3IsNull, setField3IsNull] = useState(true);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<ISetting> = {
    key: '',
    value: '',
    description: '',
    editFlag: false,
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getSettingStatus(state, actionTypes.SETTING_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (val) => {
      const formData: ISettingForm = {
        key: val.key,
        value: val.value,
        description: val.description,
        editFlag: val.editFlag,
      };
      const response = await actions.updatePUT(val.settingsId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_CONFIG_UPDATE_SUCCESS,
            formData.key ?? val.key
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      setField1IsNull(true);
      setField2IsNull(true);
      setField3IsNull(true);
      actions.listGET();
    },
    [actions]
  );
  const booleanTrue = true;
  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_CONFIGUTATION_SETTINGS}
      content={
        <div className={style.content}>
          <ConfigurationSettingsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable1={(value) => setField1IsNull(value)}
            handleEnable2={(value) => setField2IsNull(value)}
            handleEnable3={(value) => setField3IsNull(value)}
            isEdit={booleanTrue}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
              setField1IsNull(true);
              setField2IsNull(true);
              setField3IsNull(true);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={field1IsNull && field2IsNull && field3IsNull}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default ConfigurationSettingsEdit;
